import { ReactElement, useCallback } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getAdmissionProcessesFormAction } from './actions';

export interface FormLoaderProps<T> {
  children: (props: { data: T; refresh: () => Promise<void> }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  {
    processTypes: any[];
    periods: any[];
  }
>();

export const FormLoaderConsumer = FetchConsumer;

export default function FormLoader({
  children,
}: FormLoaderProps<{
  processTypes: any[];
  periods: any[];
}>) {
  const request = useCallback(async () => {
    const result = await getAdmissionProcessesFormAction();
    if (result.success) {
      return { data: result.data };
    }
    throw new Error('Failed to fetch form data');
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.error.message || 'Error desconocido'}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
